import type {User, UserRole} from '@services/auth';

export const ROLE_LABEL: Record<UserRole, string> = {
  SUPER_ADMIN: 'Супер Админ',
  ADMIN: 'Админ',
  MANAGER: 'Менеджер',
  ORGANIZER: 'Организатор',
  ACCOUNTANT: 'Бухгалтер',
  SUPER_CASHIER: 'Супер-кассир',
  CASHIER: 'Кассир',
  PARTNER: 'Партнёр',
  ARTIST: 'Артист',
  CONTROLLER: 'Контроллёр',
  THEATER_CONTROLLER: 'Контроллёр площадок',
  EVENT_CONTROLLER: 'Контроллёр событий',
};

// Первая буква имени/email для аватарки.
export const firstInitial = (user: User | null): string => {
  if (!user) return '?';
  return (user.fullName ?? user.email ?? '?').slice(0, 1).toUpperCase();
};

// Имя для шапки: fullName или email.
export const displayName = (user: User | null): string => {
  if (!user) return '—';
  return user.fullName ?? user.email ?? '—';
};
